import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useMemo } from 'react';
import classNames from 'classnames';
import SwiperCore, { Autoplay } from 'swiper';
import { createTaroSwiperEvent } from '../_util/taroEvent';
import useMergedState from '../_util/hooks/useMergedState';
import toArray from '../_util/children/toArray';
SwiperCore.use([Autoplay]);
const Swiper = ({ id, className, style, indicatorDots = false, indicatorColor = 'rgba(0, 0, 0, .3)', indicatorActiveColor = '#333', autoplay, current, 
// currentItemId,
interval = 5000, duration = 500, circular = false, vertical = false, 
// previousMargin = '0px',
// nextMargin = '0px',
// snapToEdge = false,
displayMultipleItems = 1, 
// skipHiddenItemLayout = false,
// easingFunction = 'default',
children, onChange, onAnimationFinish }) => {
    const swiperElRef = useRef(null);
    const swiperRef = useRef(null);
    const onChangeRef = useRef(onChange);
    const onAnimationFinishRef = useRef(onAnimationFinish);
    const [mergedCurrent, setMergedCurrent] = useMergedState(0, {
        defaultValue: current
    });
    useEffect(() => {
        if (!swiperElRef.current) {
            return;
        }
        const options = {
            direction: vertical ? 'vertical' : 'horizontal',
            loop: circular,
            slidesPerView: displayMultipleItems,
            initialSlide: mergedCurrent,
            speed: duration,
            observer: true,
            observeParents: true,
            on: {
                slideChange(swiper) {
                    var _a;
                    const taroEvent = createTaroSwiperEvent('change', swiper);
                    setMergedCurrent(taroEvent.detail.current);
                    (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, taroEvent);
                },
                transitionEnd(swiper) {
                    var _a;
                    const taroEvent = createTaroSwiperEvent('animationfinish', swiper);
                    (_a = onAnimationFinishRef.current) === null || _a === void 0 ? void 0 : _a.call(onAnimationFinishRef, taroEvent);
                }
            }
        };
        if (autoplay) {
            options.autoplay = {
                delay: interval,
                stopOnLastSlide: true,
                disableOnInteraction: false
            };
        }
        const swiper = swiperRef.current = new SwiperCore(swiperElRef.current, options);
        return () => {
            swiper.destroy();
        };
    }, []);
    useEffect(() => {
        const swiper = swiperRef.current;
        if (!swiper) {
            return;
        }
        if (autoplay) {
            swiper.autoplay.start();
        }
        else {
            swiper.autoplay.stop();
        }
    }, [autoplay]);
    const items = useMemo(() => toArray(children), [children]);
    return (_jsxs("div", Object.assign({ ref: swiperElRef, id: id, style: style, className: classNames('swiper-container', className) }, { children: [_jsx("div", Object.assign({ className: 'swiper-wrapper' }, { children: children })), indicatorDots && (_jsx("div", Object.assign({ className: classNames('taro-swiper__dots', {
                    'taro-swiper__dots-vertical': vertical,
                    'taro-swiper__dots-horizontal': !vertical
                }) }, { children: items.map((_, index) => (_jsx("div", { className: 'taro-swiper__dot', style: {
                        backgroundColor: mergedCurrent === index
                            ? indicatorActiveColor
                            : indicatorColor
                    } }, index))) })))] })));
};
export default Swiper;
